import { InfoBarDataFormValues } from "../components";
import { InfoBarData } from "../content.types";

export const getInitialInfoBarDataFormValues = (
  editableInfoBarData: InfoBarData | undefined
): InfoBarDataFormValues => ({
  shippingData: editableInfoBarData?.freeShipping ?? {
    header: "",
    description: "",
    content: ""
  },
  returnsData: editableInfoBarData?.freeReturns ?? {
    header: "",
    description: "",
    content: ""
  }
});
